import React, { memo, useCallback, useRef } from 'react';
import { StyledRemoveIcon, StyledListItem, StyledActionIcon, StyledSecondAction } from './styled';
import { ListItemIcon } from '../../../../list-item-icon';
import { ListItemContent } from '../../../../list-item-content';
export const Item = memo(function Item({ item, onRemove, onClick, isHistory }) {
    const stopBulkRef = useRef(false);
    const remove = useCallback(() => {
        stopBulkRef.current = true;
        onRemove(item);
    }, [onRemove, item]);
    const click = useCallback(() => {
        if (!stopBulkRef.current) {
            onClick(item);
        }
        stopBulkRef.current = false;
    }, [onClick, item]);
    return (React.createElement(StyledListItem, { button: true, onClick: click },
        React.createElement(ListItemIcon, null, isHistory ? React.createElement(StyledActionIcon, { name: "history" }) : React.createElement(StyledActionIcon, { name: "bookmark" })),
        React.createElement(ListItemContent, null, item.name),
        React.createElement(StyledSecondAction, null,
            React.createElement(StyledRemoveIcon, { onClick: remove, height: "16" }))));
});
